export default __webpack_public_path__ + "static/hooked-on-you-729f3ed55e6c15a93f3f9eb11bda0573.jpg";